module.exports = __webpack_public_path__ + "static/patrik-close-min-04c1ef6d2ab9e92f3d4feedc8fb21e5f.jpg";